import React from 'react';
import { ExtraAvecRemise, TypeRemiseExtra, montantRemiseExtra, quantiteOfferte } from '../../lib/remiseExtras';

/**
 * Remise d'une ligne (prestation ou extra) : une remise en % ou en euros, ou « offert » (toute la ligne), et — dès qu'il y a
 * plus d'une unité — un nombre d'unités OFFERTES. Le montant retranché s'affiche à côté ; il apparaît ensuite sur la facture
 * comme une ligne de remise (ou « — N offerts ») sous la ligne concernée.
 */
export function RemiseExtraField({ extra, onChange }: {
    extra: ExtraAvecRemise;
    onChange: (patch: { discount_type?: TypeRemiseExtra | null; discount_value?: number; offered_quantity?: number }) => void;
}) {
    const type = extra.discount_type || '';
    const retranche = montantRemiseExtra(extra);
    const quantite = Number(extra.quantity) || 1;
    return (
        <div className="flex items-center gap-2 flex-wrap text-[11px] text-content-muted">
            <span className="font-bold uppercase tracking-widest text-[10px]">Remise</span>
            <select value={type}
                onChange={(e) => {
                    const v = (e.target.value || null) as TypeRemiseExtra | null;
                    onChange({ discount_type: v, discount_value: v === 'percent' || v === 'amount' ? (extra.discount_value || 0) : 0, ...(v === 'offered' ? { offered_quantity: 0 } : {}) });
                }}
                className="bg-transparent text-xs text-content outline-none border border-border rounded-md px-1.5 py-0.5">
                <option value="">Aucune</option>
                <option value="percent">En %</option>
                <option value="amount">En €</option>
                <option value="offered">Tout offert</option>
            </select>
            {(type === 'percent' || type === 'amount') && (
                <input type="number" min={0} step={type === 'percent' ? 1 : 0.01} value={extra.discount_value || ''} placeholder={type === 'percent' ? '%' : '€'}
                    onChange={(e) => onChange({ discount_type: type, discount_value: Math.max(0, Number(e.target.value || 0)) })}
                    className="w-16 bg-surface border border-border rounded-md px-1.5 py-0.5 text-xs text-content text-right outline-none focus:border-brand-500" />
            )}
            {quantite > 1 && type !== 'offered' && (
                <label className="inline-flex items-center gap-1">
                    <span>dont</span>
                    <input type="number" min={0} max={quantite} step={1} value={extra.offered_quantity || ''} placeholder="0"
                        onChange={(e) => onChange({ offered_quantity: Math.max(0, Math.min(quantite, Math.floor(Number(e.target.value) || 0))) })}
                        className="w-12 bg-surface border border-border rounded-md px-1.5 py-0.5 text-xs text-content text-right outline-none focus:border-brand-500" />
                    <span>offert{quantiteOfferte(extra) > 1 ? 's' : ''} sur {quantite}</span>
                </label>
            )}
            {retranche > 0 && <span className="font-semibold text-emerald-500">−{retranche.toFixed(2).replace('.', ',')} €</span>}
        </div>
    );
}
